import React from "react";
import BibliographyTable from "../../components/tables/BibliographyTable";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

const MainBibliographyPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Bibliography
        </Button>
        <Typography variant="h1">Bibliographies</Typography>
      </Box>
      <BibliographyTable />
    </Box>
  );
};

export default MainBibliographyPage;

